(function () {
  'use strict';

  if (window.__brilintonHomepageWorldsLoaded) return;
  window.__brilintonHomepageWorldsLoaded = true;


  function HomepageWorldSection(root) {
    this.root = root;
    this.railCleanups = new Map();
    this.railRefreshers = new Map();
    this.bindRails(root);
  }

  HomepageWorldSection.prototype.destroy = function () {
    this.railCleanups.forEach(function (cleanup) { cleanup(); });
    this.railCleanups.clear();
    this.railRefreshers.clear();
  };

  HomepageWorldSection.prototype.bindRails = function (scope) {
    var self = this;
    (scope || this.root).querySelectorAll('[data-homepage-rail-shell]').forEach(function (shell) {
      self.bindRail(shell);
    });
  };

  HomepageWorldSection.prototype.bindRail = function (shell) {
    if (!shell) return;
    if (this.railCleanups.has(shell)) this.railCleanups.get(shell)();
    this.railRefreshers.delete(shell);

    var viewport = shell.querySelector('[data-homepage-rail-viewport]');
    var track = shell.querySelector('[data-homepage-rail-track]');
    var previous = shell.querySelector('[data-homepage-rail-previous]');
    var next = shell.querySelector('[data-homepage-rail-next]');
    if (!viewport || !track) return;

    var frame = 0;
    var resizeObserver = null;
    var imageListeners = [];
    var dragState = null;
    var suppressClickUntil = 0;
    viewport.scrollLeft = 0;

    function update() {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        var overflow = viewport.scrollWidth > viewport.clientWidth + 2;
        shell.classList.toggle('has-overflow', overflow);
        if (previous) {
          previous.hidden = !overflow;
          previous.disabled = !overflow || viewport.scrollLeft <= 2;
          previous.setAttribute('aria-disabled', previous.disabled ? 'true' : 'false');
        }
        if (next) {
          next.hidden = !overflow;
          next.disabled = !overflow || viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
          next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
        }
      });
    }

    function stepWidth() {
      var first = track.querySelector('.homepage-product-world__product-slide');
      if (!first) return Math.max(260, viewport.clientWidth * .82);
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function scroll(direction) {
      viewport.scrollBy({ left: direction * stepWidth(), behavior: 'smooth' });
    }


    function onPointerDown(event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (event.target && event.target.closest && event.target.closest('.card-product__media-controls, .slider_icon')) return;

      dragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startScrollLeft: viewport.scrollLeft,
        moved: false,
        captured: false
      };
    }

    function onPointerMove(event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      var delta = event.clientX - dragState.startX;
      if (!dragState.moved && Math.abs(delta) < 5) return;

      if (!dragState.moved) {
        dragState.moved = true;
        viewport.classList.add('is-dragging');

        if (viewport.setPointerCapture) {
          viewport.setPointerCapture(event.pointerId);
          dragState.captured = true;
        }
      }

      viewport.scrollLeft = dragState.startScrollLeft - delta;
      event.preventDefault();
      update();
    }

    function endDrag(event) {
      if (!dragState || (event && event.pointerId !== dragState.pointerId)) return;

      if (dragState.moved) suppressClickUntil = Date.now() + 300;

      if (
        dragState.captured &&
        viewport.releasePointerCapture &&
        viewport.hasPointerCapture &&
        viewport.hasPointerCapture(dragState.pointerId)
      ) {
        viewport.releasePointerCapture(dragState.pointerId);
      }

      dragState = null;
      viewport.classList.remove('is-dragging');
      update();
    }

    function suppressDraggedClick(event) {
      if (event.target && event.target.closest && event.target.closest('.card-product__media-controls, .slider_icon')) return;
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }
    }

    function preventNativeDrag(event) {
      event.preventDefault();
    }

    var onPrevious = function () { scroll(-1); };
    var onNext = function () { scroll(1); };
    if (previous) previous.addEventListener('click', onPrevious);
    if (next) next.addEventListener('click', onNext);
    viewport.addEventListener('scroll', update, { passive: true });
    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', endDrag);
    viewport.addEventListener('click', suppressDraggedClick, true);
    viewport.addEventListener('dragstart', preventNativeDrag);
    viewport.classList.add('is-draggable');
    /* One resize owner. ResizeObserver already reacts to the rail geometry changes
       caused by viewport/device emulation; only fall back to window.resize where
       ResizeObserver is unavailable. This avoids duplicate remeasurement storms
       while dragging DevTools across responsive breakpoints. */
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(viewport);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    track.querySelectorAll('img').forEach(function (image) {
      if (image.complete) return;
      image.addEventListener('load', update, { once: true });
      image.addEventListener('error', update, { once: true });
      imageListeners.push(image);
    });

    requestAnimationFrame(function () {
      viewport.scrollLeft = 0;
      requestAnimationFrame(update);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update).catch(function () {});

    var cleanup = function () {
      window.cancelAnimationFrame(frame);
      if (previous) previous.removeEventListener('click', onPrevious);
      if (next) next.removeEventListener('click', onNext);
      viewport.removeEventListener('scroll', update);
      viewport.removeEventListener('pointerdown', onPointerDown);
      viewport.removeEventListener('pointermove', onPointerMove);
      viewport.removeEventListener('pointerup', endDrag);
      viewport.removeEventListener('pointercancel', endDrag);
      viewport.removeEventListener('lostpointercapture', endDrag);
      viewport.removeEventListener('click', suppressDraggedClick, true);
      viewport.removeEventListener('dragstart', preventNativeDrag);
      viewport.classList.remove('is-draggable', 'is-dragging');
      if (!resizeObserver) window.removeEventListener('resize', update);
      if (resizeObserver) resizeObserver.disconnect();
      imageListeners.forEach(function (image) {
        image.removeEventListener('load', update);
        image.removeEventListener('error', update);
      });
    };

    this.railCleanups.set(shell, cleanup);
    this.railRefreshers.set(shell, update);
  };


  HomepageWorldSection.prototype.refresh = function () {
    this.railRefreshers.forEach(function (refresh) { refresh(); });
  };

  function boot(root) {
    if (root.__homepageWorldSection) root.__homepageWorldSection.destroy();
    root.__homepageWorldSection = new HomepageWorldSection(root);
  }

  function bootAll(scope) {
    var node = scope || document;
    if (node.matches && node.matches('[data-homepage-world-section]')) boot(node);
    node.querySelectorAll('[data-homepage-world-section]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootAll(event.target || document);
  });

  window.addEventListener('brilinton:layout-refresh', function () {
    document.querySelectorAll('[data-homepage-world-section]').forEach(function (root) {
      if (root.__homepageWorldSection) root.__homepageWorldSection.refresh();
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    var root = target && target.matches && target.matches('[data-homepage-world-section]')
      ? target
      : target && target.querySelector && target.querySelector('[data-homepage-world-section]');
    if (root && root.__homepageWorldSection) root.__homepageWorldSection.destroy();
  });
})();